import { createUseStyles } from "react-jss";
import { resolveQuestionErrorToLabelGap } from "../../theme/errorThemeTokens";
import { Theme } from "../../types/Theme";

export default createUseStyles({
    /** New theme: flex row so icon and message are vertically centered together. */
    errorRow: {
        display: "inline-flex",
        alignItems: "center",
        marginTop: 14.5,
        marginRight: 0,
        marginBottom: ({ theme }: { theme: Theme }) => resolveQuestionErrorToLabelGap(theme) ?? 0,
        marginLeft: 0,
    },
    icon: {
        composes: "validation-error__icon",
        position: "relative",
        float: ({ theme }: { theme: Theme }) => (theme.UseModernTheme ? "none" : "left"),
        flexShrink: 0,
        fontSize: ({ theme }: { theme: Theme }) =>
            theme.UseModernTheme
                ? undefined
                : theme.QuestionErrorFontSize != null
                  ? Math.round(theme.QuestionErrorFontSize * 1.25)
                  : theme.ErrorIconSize ?? 30,
        color: ({ theme }: { theme: Theme }) => theme.ErrorColor,
        marginRight:({ theme }: { theme: Theme }) => (theme.UseModernTheme ? 4 : 14.5),
    },
    /** New theme question error (inline SVG). */
    iconSvg: {
        width: 16,
        height: 16,
        flexShrink: 0,
    },
    dynamicIcon: {
        left: ({ theme }: { theme: Theme }) => (theme.UseModernTheme ? 0 : -44),
        bottom: ({ theme }: { theme: Theme }) => (theme.UseModernTheme ? 1 : 0),
    },
    validationError: {
        composes: "validation-error",
        position: "relative",
        fontWeight: ({ theme }: { theme: Theme }) => theme.ErrorFontWeight ?? 700,
        color: ({ theme }: { theme: Theme }) => theme.ErrorColor,
        marginTop: ({ theme }: { theme: Theme }) => (theme.UseModernTheme ? 0 : 14.5),
        marginRight: 0,
        marginBottom: ({ theme }: { theme: Theme }) => (theme.UseModernTheme ? 0 : 14.5),
        marginLeft: 0,
        fontSize: ({ theme }: { theme: Theme }) =>
            theme.QuestionErrorFontSize != null ? theme.QuestionErrorFontSize : "inherit",
    },
    dynamicValidationError: {
        left: ({ theme }: { theme: Theme }) => (theme.UseModernTheme ? 0 : -41),
    },
});
